import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "../translations/locales/en/index";
import frTranslation from "../translations/locales/fr/index";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
    },
    fallbackLng: "en",
    lng: localStorage.getItem("language") || "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
